module.exports = __webpack_public_path__ + "img/saveExit.e54fa106.svg";